module.exports = __webpack_public_path__ + "img/3.491d765f.jpg";